var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('div',{staticClass:"bg-white"},[_c('FilterSystem',{staticClass:"display-inline",attrs:{"columns":_vm.defaulOptions,"reset":false,"sort":_vm.sort,"dir":_vm.dir,"filterSystem":_vm.filtersSystem,"filterOldQuery":_vm.oldQuery},on:{"callApi":_vm.callApi}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }